import { http } from "../client";
import axios from "axios";
export var DeactivateDeviceRequestFailureVariant;
(function (DeactivateDeviceRequestFailureVariant) {
    DeactivateDeviceRequestFailureVariant[DeactivateDeviceRequestFailureVariant["NotFound"] = 0] = "NotFound";
})(DeactivateDeviceRequestFailureVariant || (DeactivateDeviceRequestFailureVariant = {}));
var mapErrorToFailureVariant = function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
            return DeactivateDeviceRequestFailureVariant.NotFound;
    }
    return null;
};
export var deactivateDevice = function (id) {
    return http.api
        .post("devices/" + id + "/deactivate")
        .then(function (response) { return response.data; })
        .then(function (data) { return ({ id: data.device_id }); })
        .catch(function (error) { return Promise.reject(mapErrorToFailureVariant(error)); });
};
